import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { BatchImport } from '../components/program-cap/batch-import/batch-import';

const ProgramCapBatchImportPage = (): JSX.Element => (
  <HHStack
    flex={1}
    gap={4}
    spacing={4}
    sx={{ marginTop: 4, overflow: 'hidden' }}
  >
    <HHStack sx={{ margin: 4 }}>
      <HHTypography hhVariant="section-title">
        Program Cap Batch Import
      </HHTypography>
    </HHStack>
    <BatchImport />
  </HHStack>
);

export default ProgramCapBatchImportPage;
